var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 321 321",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-357,-360)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bottle",
    transform: "matrix(0.3125,0,0,0.16,21.7447,360.864)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1074,
    y: 0,
    width: 1024,
    height: 2000,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.2,0,0,6.25,-814,-7437.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M690,1500L690,1340C690.271,1315.46 696.938,1288.8 710,1260L790,1260C802.911,1286.67 809.88,1313.33 810,1340L810,1500L690,1500Z",
    style: {
      fill: "none",
      stroke: "rgb(51,51,51)",
      strokeWidth: "15.03px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 1240,
    width: 60,
    height: 20,
    style: {
      fill: "none",
      stroke: "rgb(51,51,51)",
      strokeWidth: "15.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710,1240L710,1210C710.605,1204.48 713.574,1200.86 720,1200L780,1200C785.426,1200.94 788.648,1204.4 790,1210L790,1240L710,1240Z",
    style: {
      fill: "none",
      stroke: "rgb(51,51,51)",
      strokeWidth: "15.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740,1292.01C727.86,1303.29 720.771,1324.46 720,1340",
    style: {
      fill: "none",
      stroke: "rgb(51,51,51)",
      strokeWidth: "15.03px"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottle);
export default __webpack_public_path__ + "static/media/bottle.886dbb56840992bbd1cdd0fa6028fec2.svg";
export { ForwardRef as ReactComponent };